import { Link } from "react-router-dom"

import { aiCreditLimitMessage } from "@/lib/ai-credit-errors"

export function AiCreditUsageLink({ error }) {
  if (!aiCreditLimitMessage(error)) return null

  return (
    <Link className="font-semibold underline underline-offset-2" to="/ai-usage">
      View AI usage
    </Link>
  )
}
